import { useEffect, useState } from 'react'

export const useCommandPaletteKeyboard = (
  itemCount: number,
  onSelect: (index: number) => void,
  isOpen: boolean,
) => {
  const [selectedIndex, setSelectedIndex] = useState(0)

  useEffect(() => {
    if (!isOpen) return
    if (itemCount === 0) return

    const handleKeyDown = (event: KeyboardEvent) => {
      switch (event.key) {
        case 'ArrowDown':
          event.preventDefault()
          event.stopPropagation()
          setSelectedIndex(prev => (prev + 1) % itemCount)
          break
        case 'ArrowUp':
          event.preventDefault()
          event.stopPropagation()
          setSelectedIndex(prev => (prev - 1 + itemCount) % itemCount)
          break
        case 'Enter':
          event.preventDefault()
          event.stopPropagation()
          onSelect(selectedIndex)
          break
      }
    }

    document.addEventListener('keydown', handleKeyDown)

    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [isOpen, itemCount, selectedIndex, onSelect])

  useEffect(() => {
    setSelectedIndex(currentSelectedIndex =>
      itemCount === 0 || currentSelectedIndex > 0 ? 0 : currentSelectedIndex,
    )
  }, [itemCount])

  return { selectedIndex }
}
